import React, { useCallback } from 'react';

import { Container, Grid, Header } from 'semantic-ui-react';

const Dashboard = () => (
    <Grid.Row className="hero dashboard">
        <Grid.Column computer="11" mobile="12">
            <Container>
                <Header as="h1" content="Manage your private On Site network" />
                <Header as="h4" content="Configure and monitor users and their devices at scale" />
            </Container>
        </Grid.Column>
    </Grid.Row>
);

const Sims = () => (
    <Grid.Row className="hero sims">
        <Grid.Column computer="11" mobile="12">
            <Container>
                <Header as="h1" content="Manage On Site SIMs" />
            </Container>
        </Grid.Column>
    </Grid.Row>
);

const Users = () => (
    <Grid.Row className="hero users">
        <Grid.Column computer="11" mobile="12">
            <Container>
                <Header as="h1" content="Manage On Site users, roles and locations" />
            </Container>
        </Grid.Column>
    </Grid.Row>
);

const Monitoring = () => (
    <Grid.Row className="hero monitoring">
        <Grid.Column computer="11" mobile="12">
            <Container>
                <Header as="h1" content="Monitor On Site network, devices and services" />
            </Container>
        </Grid.Column>
    </Grid.Row>
);

const Maintenance = () => (
    <Grid.Row className="hero maintenance">
        <Grid.Column computer="11" mobile="12">
            <Container>
                <Header as="h1" content="Track and maintain your On Site network" />
            </Container>
        </Grid.Column>
    </Grid.Row>
);

const HeroImage = ({ hero = false }) => {
    const SubNav = useCallback(() => {
        if (hero) {
            switch (hero) {
                case 'dashboard':
                    return <Dashboard />;

                case 'sims':
                case 'backup':
                    return <Sims />;

                case 'users':
                case 'roles':
                    return <Users />;

                case 'monitoring':
                    return <Monitoring />;

                case 'maintenance':
                    return <Maintenance />;
                default:
            }
        }
        return null;
    }, [hero]);

    return <SubNav hero={hero} />;
};

export default HeroImage;
